module.exports={
    "supportedLanguages": [
        {
            "languageCodes": [
                "ar",
                "ar-AE",
                "ar-BH",
                "ar-DZ",
                "ar-EG",
                "ar-IQ",
                "ar-JO",
                "ar-KW",
                "ar-LB",
                "ar-LY",
                "ar-MA",
                "ar-OM",
                "ar-QA",
                "ar-SA",
                "ar-SY",
                "ar-TN",
                "ar-YE"
            ],
            "defaultLanguageCode": "ar",
            "nativeDisplayName": "العربية",
            "displayName": "Arabic"
        },
        {
            "languageCodes": ["zh-CN", "zh-Hans", "zh-SG", "zh"],
            "defaultLanguageCode": "zh-Hans",
            "nativeDisplayName": "中文(简体)",
            "displayName": "Chinese (Simplified)"
        },
        {
            "languageCodes": ["zh-Hant", "zh-HK", "zh-MO", "zh-TW"],
            "defaultLanguageCode": "zh-Hant",
            "nativeDisplayName": "中文(繁體)",
            "displayName": "Chinese (Traditional)"
        },
        {
            "languageCodes": ["da", "da-DK"],
            "defaultLanguageCode": "da",
            "nativeDisplayName": "Dansk",
            "displayName": "Danish"
        },
        {
            "languageCodes": ["nl", "nl-BE", "nl-NL"],
            "defaultLanguageCode": "nl",
            "nativeDisplayName": "Nederlands",
            "displayName": "Dutch"
        },
        {
            "languageCodes": [
                "en",
                "en-029",
                "en-AU",
                "en-BZ",
                "en-CA",
                "en-GB",
                "en-IE",
                "en-IN",
                "en-JM",
                "en-MY",
                "en-NZ",
                "en-PH",
                "en-SG",
                "en-TT",
                "en-US",
                "en-ZA",
                "en-ZW"
            ],
            "defaultLanguageCode": "en",
            "nativeDisplayName": "English",
            "displayName": "English"
        },
        {
            "languageCodes": ["fi", "fi-FI"],
            "defaultLanguageCode": "fi",
            "nativeDisplayName": "Suomi",
            "displayName": "Finnish"
        },
        {
            "languageCodes": ["fr-CA", "fr"],
            "defaultLanguageCode": "fr-CA",
            "nativeDisplayName": "Français (Canada)",
            "displayName": "French (Canadian)"
        },
        {
            "languageCodes": [
                "de",
                "de-AT",
                "de-CH",
                "de-DE",
                "de-LI",
                "de-LU"
            ],
            "defaultLanguageCode": "de",
            "nativeDisplayName": "Deutsch",
            "displayName": "German"
        },
        {
            "languageCodes": ["he", "he-IL"],
            "defaultLanguageCode": "he",
            "nativeDisplayName": "עברית",
            "displayName": "Hebrew"
        },
        {
            "languageCodes": ["is", "is-IS"],
            "defaultLanguageCode": "is",
            "nativeDisplayName": "Íslenska",
            "displayName": "Icelandic"
        },
        {
            "languageCodes": ["it", "it-CH", "it-IT"],
            "defaultLanguageCode": "it",
            "nativeDisplayName": "Italiano",
            "displayName": "Italian"
        },
        {
            "languageCodes": ["ja", "ja-JP"],
            "defaultLanguageCode": "ja",
            "nativeDisplayName": "日本語",
            "displayName": "Japanese"
        },
        {
            "languageCodes": ["ko", "ko-KR"],
            "defaultLanguageCode": "ko",
            "nativeDisplayName": "한국어",
            "displayName": "Korean"
        },
        {
            "languageCodes": ["ms", "ms-BN", "ms-MY"],
            "defaultLanguageCode": "ms",
            "nativeDisplayName": "Bahasa Melayu",
            "displayName": "Malay"
        },
        {
            "languageCodes": [
                "pt",
                "pt-AO",
                "pt-BR",
                "pt-CH",
                "pt-CV",
                "pt-FR",
                "pt-GQ",
                "pt-GW",
                "pt-LU",
                "pt-MO",
                "pt-MZ",
                "pt-PT",
                "pt-ST",
                "pt-TL"
            ],
            "defaultLanguageCode": "pt",
            "nativeDisplayName": "Português",
            "displayName": "Portuguese"
        },
        {
            "languageCodes": ["ru", "ru-RU"],
            "defaultLanguageCode": "ru",
            "nativeDisplayName": "Русский",
            "displayName": "Russian"
        },
        {
            "languageCodes": [
                "es",
                "es-AR",
                "es-BO",
                "es-CL",
                "es-CO",
                "es-CR",
                "es-DO",
                "es-EC",
                "es-ES",
                "es-GT",
                "es-HN",
                "es-MX",
                "es-NI",
                "es-PA",
                "es-PE",
                "es-PR",
                "es-PY",
                "es-SV",
                "es-US",
                "es-UY",
                "es-VE"
            ],
            "defaultLanguageCode": "es",
            "nativeDisplayName": "Español",
            "displayName": "Spanish"
        },
        {
            "languageCodes": ["sv", "sv-FI", "sv-SE"],
            "defaultLanguageCode": "sv",
            "nativeDisplayName": "Svenska",
            "displayName": "Swedish"
        },
        {
            "languageCodes": ["ta", "ta-IN"],
            "defaultLanguageCode": "ta",
            "nativeDisplayName": "தமிழ்",
            "displayName": "Tamil"
        },
        {
            "languageCodes": ["tr", "tr-TR"],
            "defaultLanguageCode": "tr",
            "nativeDisplayName": "Türkçe",
            "displayName": "Turkish"
        }
    ]
}
